<template>
  <div class="rank-table-container">
    <div class="header-content" style="align-items: center;">
      <div style="font-size: 24px;color: white;">抖音互动玩法大数据</div>
      <div style="font-size: 20px;font-weight:bold;margin-top: 1%">{{ displayTime }}</div>
    </div>

    <!-- 弹出窗：加载中提示，使用 v-model 绑定 isLoading -->
    <el-dialog
        v-model="isLoading"
        width="300px"
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        custom-class="loading-dialog"
    >
      <div style="text-align:center; font-size: 24px; margin-bottom: 10px;">
        数据加载中，请稍后…
      </div>
      <div style="text-align:center;">
        <el-icon><loading /></el-icon>
      </div>
    </el-dialog>

    <!-- 第一行：开始日期、结束日期 -->
    <div style="text-align: center;margin-bottom: 10px; margin-top: 6%;padding-left: 16px;padding-right: 16px;border-radius: 8px;">
      <div
          class="datetime-container background-box"
          style="display: inline-flex; gap: 40px; justify-content: center;"
      >
        <div class="datetime-group" style="display: inline-flex; align-items: center;">
          <label for="startDate" style="margin-right: 2%; margin-top:2%;margin-left: 2%">开始时间:</label>
          <span style="display:block;width:40%;margin-top: 1%;">
            <!-- 使用 vue-datetime3 替代原来的 el-date-picker -->
            <datetime
                input-style="width:100%;font-size:16px;"
                v-model="startDate"
                type="date"
                :format="{
                              year: 'numeric',
                              month: '2-digit',
                              day: '2-digit'
                            }"
                :max-datetime="new Date().toISOString()"
                class="dt-input"
            />
          </span>
        </div>
        <div
            class="datetime-group"
            v-show="queryType === 'day'"
            style="display: inline-flex; align-items: center;"
        >
          <label for="endDate" style="margin-right: 2%; margin-top:2%;margin-left: 2%">结束时间:</label>
          <!-- 同样使用 vue-datetime3 替代原来的 el-date-picker -->
          <span style="display:block;width:40%;margin-top: 1%;">
            <datetime
                input-style="width:100%;font-size:16px;"
                v-model="endDate"
                type="date"
                :format="{
              year: 'numeric',
              month: '2-digit',
              day: '2-digit'
            }"
                :max-datetime="new Date().toISOString()"
                class="dt-input"
            />
          </span>
        </div>
      </div>
    </div>

    <!-- 第二行：单选框(按小时/按天)、快速选择、玩法选择、查询按钮 -->
    <div style="margin-bottom: 10px; text-align: center;padding-left: 16px;padding-right: 16px;border-radius: 8px;">
      <div
          class="form-row background-box"
          style="display: inline-flex; align-items: center; gap: 20px;"
      >
        <el-radio-group
            v-model="queryType"
            style="display: inline-flex; gap: 2%; min-width: 40%; margin-left: 2%; margin-top: 1%;"
        >
          <el-radio :value="'hour'">按小时查询</el-radio>
          <el-radio :value="'day'">按天查询</el-radio>
        </el-radio-group>

        <!-- 这里修改为模态框按钮 -->
        <label style="min-width: 15%; margin-top:1%;margin-left: 2%">快速选择：</label>
        <el-button @click="showQuickSelectDialog" style="min-width: 10%; margin-left: 2%">{{ quickSelect }}</el-button>

<!--        &lt;!&ndash; 这里修改为模态框按钮 &ndash;&gt;-->
<!--        <el-button @click="showPlaySelectDialog" style="width: 20%; margin-left: 2%; margin-right: 2%">-->
<!--          {{ selectedPlay || '选择玩法' }}-->
<!--        </el-button>-->

        <el-button type="primary" @click="onSearch" style="min-width: 10%;margin-right: 2%">
          查询
        </el-button>
      </div>
    </div>

    <!-- 选择快速选择日期的模态框 -->
    <el-dialog
        v-model="quickSelectDialogVisible"
        title="选择日期"
        width="30%"
    >
      <div>
        <el-button
            v-for="option in quickSelectOptions"
            :key="option.value"
            style="width: 60%;margin:2%"
            @click="selectQuickDate(option.value)"
        >
          {{ option.label }}
        </el-button>
      </div>
      <template #footer>
        <el-button @click="quickSelectDialogVisible = false">取消</el-button>
      </template>
    </el-dialog>

    <!-- 选择玩法的模态框 -->
    <el-dialog
        v-model="playSelectDialogVisible"
        title="选择玩法"
        width="30%"
        :style="{ top: dialogTop + 'px' }"
    >
      <div>
        <el-button
            v-for="item in totalPlayOptions"
            :key="item"
            style="margin: 5px"
            @click="selectPlay(item)"
        >
          {{ item }}
        </el-button>
      </div>
      <template #footer>
        <el-button @click="playSelectDialogVisible = false">取消</el-button>
      </template>
    </el-dialog>

    <!-- 总体分析 -->
    <div style="text-align: center;">
      <h2>总体分析</h2>
      <div style="display: inline-block;">
        <v-chart
            class="chart-box"
            :option="lineChartOptions"
            style="width: 600px; height: 500px;"
        />
      </div>
    </div>

    <!-- 玩法分类统计：仅当 selectedPlay === 'statists_total' 时显示 -->
    <div v-if="selectedPlay === 'statists_total'" style="text-align: center;">
      <h2>玩法分类统计</h2>
      <div style="display: inline-block;">
        <v-chart
            class="chart-box"
            :option="pieChartOptions"
            style="width: 600px; height: 400px; margin-bottom: 20px;"
        />
      </div>

      <h2>分类上榜数据统计</h2>
      <div style="margin: 0 5% 20px;">
        <el-table
            :data="tableData"
            style="width: 100%;"
            :border="true"
            :header-row-style="headerRowStyle"
            :header-cell-style="headerCellStyle"
            :row-class-name="getRowClassName"
        >
          <!-- 总活跃度列，使用formatter将数值变成 x.x万 -->
          <el-table-column
              prop="type"
              label="类型"
              align="center"
          />
          <el-table-column
              prop="score_total"
              label="总活跃度"
              align="center"
              :formatter="formatScore"
          />
          <el-table-column
              prop="game_num"
              label="玩法数量"
              align="center"
          />
          <el-table-column
              prop="anchor_num"
              label="上榜主播"
              align="center"
          />
          <el-table-column
              prop="anchor_average"
              label="单人活跃"
              align="center"
          />
        </el-table>
      </div>

      <div
          style="text-align: center; margin-bottom: 20px; display: inline-flex; align-items: center; justify-content: center;"
      >
        <label style="margin-right: 8px;">选择日期:</label>
        <el-button @click="showDateDialog" style="width: 200px;">
          {{ selectedPieDate || '选择日期' }}
        </el-button>

        <!-- 弹出选择日期模态框 -->
        <el-dialog
            v-model="dateDialogVisible"
            title="选择日期"
            width="70%"
            custom-class="centered-dialog"
            :style="{ top: dialogTop + 'px' }"
        >
        <div>
          <el-button
              v-for="item in timeSegmentsWithoutTotal"
              :key="item"
              style="margin: 10px"
              @click="selectDate(item)"
          >
            {{ item }}
          </el-button>
        </div>
        <template #footer>
          <el-button @click="dateDialogVisible = false">取消</el-button>
        </template>
        </el-dialog>
      </div>
    </div>

    <!-- 热门玩法统计 -->
    <div style="text-align: center;">
      <h2>热门玩法统计</h2>
      <div style="display: inline-block;">
        <v-chart
            class="chart-box"
            :option="hotPieOptions"
            style="width: 600px; height: 400px; margin-bottom: 20px;"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue'
import axios from 'axios'

// 如果你在 main.js 中全局 app.component('v-chart', VChart)，这里就不需要再局部注册了。
// 否则需要在此处引入 VChart 并注册
import VChart from 'vue-echarts'


import { ElDialog, ElIcon } from 'element-plus'
import { Loading } from '@element-plus/icons-vue'

import { Datetime } from 'vue-datetime3'

// ---- 数据状态 ----
const queryType = ref('hour')
const startDate = ref(formatDate(new Date()))
const endDate = ref(null)
const quickSelect = ref('今天')

// 玩法选择
const selectedPlay = ref('statists_total')
const totalPlayOptions = ref([])

// 饼图、表格需要的日期选择
const selectedPieDate = ref('')

// 后端返回数据
const statisticsList = ref([])
const rankingList = ref([])

// 图表配置
const lineChartOptions = ref({})
const pieChartOptions = ref({})
const hotPieOptions = ref({})

// 表格数据
const tableData = ref([])

// 加载弹窗开关
const isLoading = ref(false)

// 用于日志
const logPrefix = '[DEBUG]'

const dateDialogVisible = ref(false)

// time_segment 列表(排除 total)
const timeSegmentsWithoutTotal = computed(() =>
    statisticsList.value.filter(item => item.time_segment !== 'total').map(item => item.time_segment)
)

// 显示在顶部的大标题
const displayTime = computed(() => {
  if (!startDate.value) return ''
  if (queryType.value === 'day') {
    return endDate.value ? `${formatDate(startDate.value)} ~ ${formatDate(endDate.value)}` : `${formatDate(startDate.value)} ~ `
  } else {
    return formatDate(startDate.value)
  }
})

// 快速选择

const quickSelectOptions = [
  { label: '今天', value: '今天' },
  { label: '昨天', value: '昨天' },
  { label: '前天', value: '前天' }
]

// 点击查询
const onSearch = async () => {
  if (!startDate.value) {
    alert('请选择开始日期')
    return
  }
  // 打开加载弹窗
  isLoading.value = true

  const params = {
    start_date: formatDate(startDate.value),
    end_date: queryType.value === 'day' && endDate.value ? formatDate(endDate.value) : formatDate(startDate.value),
    query_type: queryType.value === 'hour' ? 'hour' : 'day'
  }
  // console.log(logPrefix, '开始请求接口, 参数 => ', params)

  try {
    const resp = await axios.get('https://www.hudongwanfa.cn/api/dashboard_data', { params })
    // console.log(logPrefix, '接口响应 => ', resp.data)

    if (resp.data.code === 0) {
      const data = resp.data.data
      statisticsList.value = data.statistics_list || []
      rankingList.value = data.ranking_list || []

      // console.log(logPrefix, 'statisticsList => ', statisticsList.value)
      // console.log(logPrefix, 'rankingList => ', rankingList.value)

      // 处理玩法下拉框选项
      const totalItem = statisticsList.value.find(item => item.time_segment === 'total')
      totalPlayOptions.value = []

      // console.log('data is:', data);
      if (totalItem && totalItem.statistics) {
        for (let key in totalItem.statistics) {
          if (key !== 'statists_total') {
            totalPlayOptions.value.push(key)
          }
        }
      }

      // 默认选中“全部”
      selectedPlay.value = 'statists_total'

      // 若有 statisticsList，给 selectedPieDate 一个可用的默认值
      if (timeSegmentsWithoutTotal.value.length > 0) {
        selectedPieDate.value = timeSegmentsWithoutTotal.value[0]
      } else {
        selectedPieDate.value = ''
      }

      updateLineChart()
      updatePieAndTable()
      updateHotPieChart()
    } else {
      alert('接口返回错误：' + resp.data.message)
    }
  } catch (err) {
    console.error(logPrefix, '请求接口出错 => ', err)
    alert('请求接口失败')
  } finally {
    // 无论成功还是失败，都关闭加载弹窗
    isLoading.value = false
  }
}

/**
 * 更新折线图
 * 1) 标题改为 大盘活跃数据图
 * 2) 标题居中 => title.left = 'center'
 * 3) 本周期活跃值为0的点，隐藏圆点(使用 symbolSize 回调)
 */
const updateLineChart = () => {
  const list = statisticsList.value.filter(item => item.time_segment !== 'total')
  const xAxisData = list.map(item => item.time_segment)

  const selectedKey = selectedPlay.value
  const rawSeriesCurrent = []  // 原始本周期数据（单位: 万）
  const seriesLast = []        // 上周期数据（单位: 万）

  list.forEach(item => {
    const statObj = item.statistics[selectedKey]
    if (statObj) {
      const scoreTotal = Number(statObj.score_total) || 0
      const scoreTotalLast = Number(statObj.score_total_last) || 0
      rawSeriesCurrent.push(scoreTotal / 10000)
      seriesLast.push(scoreTotalLast / 10000)
    } else {
      rawSeriesCurrent.push(0)
      seriesLast.push(0)
    }
  })

  // 对本周期数据处理：从第一个0开始，后续数据全部设置为 null
  let cutoff = rawSeriesCurrent.findIndex(val => val === 0)
  // 如果没有找到 0，则 cutoff 为 -1，则保持原样
  let seriesCurrent = []
  if (cutoff === -1) {
    seriesCurrent = rawSeriesCurrent
  } else {
    // 保留从 0 到 cutoff-1 的数据，后续全部填 null，保证数组长度与 xAxisData 一致
    seriesCurrent = rawSeriesCurrent.slice(0, cutoff)
    for (let i = cutoff; i < rawSeriesCurrent.length; i++) {
      seriesCurrent.push(null)
    }
  }

  lineChartOptions.value = {
    backgroundColor: '#eff1f3', // 设置折线图背景色
    title: {
      text: '大盘活跃数据图',
      subtext: '单位(万)',
      left: 'center',
      top: 20
    },
    legend: {
      data: ['本周期', '上一周期'],
      top: 70
    },
    grid: {
      top: 100,
      left: '10%',
      right: '10%',
      bottom: '10%'
    },
    tooltip: {
      trigger: 'axis'
    },
    xAxis: {
      type: 'category',
      data: xAxisData,
      boundaryGap: false,
      axisLabel: {
        rotate: 45  // 例如旋转45度，也可以调整为其他角度
      }
    },
    yAxis: {
      type: 'value'
    },
    series: [
      {
        name: '本周期',
        type: 'line',
        showAllSymbol: true,
        // 连接断点（默认为 false，即遇到 null 不连接）
        connectNulls: false,
        symbolSize: 6,
        data: seriesCurrent
      },
      {
        name: '上一周期',
        type: 'line',
        data: seriesLast
      }
    ]
  }
  // console.log(logPrefix, 'lineChartOptions => ', lineChartOptions.value)
}


// 更新饼图 + 表格
const updatePieAndTable = () => {
  if (!selectedPieDate.value) {
    pieChartOptions.value = {}
    tableData.value = []
    return
  }
  const dateItem = statisticsList.value.find(item => item.time_segment === selectedPieDate.value)
  if (!dateItem || !dateItem.statistics) {
    pieChartOptions.value = {}
    tableData.value = []
    return
  }

  const stats = dateItem.statistics
  const pieData = []
  const tableArr = []

  for (let key in stats) {
    if (key === 'statists_total') continue
    const cur = stats[key]
    const score_total = Number(cur.score_total) || 0
    const game_num = cur.game_num || 0
    const anchor_num = cur.anchor_num || 0
    const anchor_average = cur.anchor_average || 0

    pieData.push({
      name: key,
      value: score_total
    })
    tableArr.push({
      type: key,
      score_total,
      game_num,
      anchor_num,
      anchor_average
    })
  }

  pieChartOptions.value = {
    backgroundColor: '#eff1f3', // 设置折线图背景色
    title: {
      text: '每日玩法占比',
      left: 'center'
    },
    tooltip: {
      trigger: 'item'
    },
    legend: {
      orient: 'vertical',
      left: 'left'
    },
    series: [
      {
        name: '玩法占比',
        type: 'pie',
        radius: '50%',
        data: pieData
      }
    ]
  }
  tableData.value = tableArr
  // console.log(logPrefix, 'pieChartOptions => ', pieChartOptions.value)
  // console.log(logPrefix, 'tableData => ', tableData.value)
}

// 更新热门玩法饼图的每个扇形的颜色
const updateHotPieChart = () => {
  if (!rankingList.value || rankingList.value.length === 0) {
    hotPieOptions.value = {}
    return
  }

  const hotData = rankingList.value.map((item, index) => ({
    name: item.game_name,
    value: Number(item.score) || 0,
    itemStyle: {
      color: hotPieColors[index] || '#000000' // 使用预定义的颜色
    }
  }))

  hotPieOptions.value = {
    backgroundColor: '#eff1f3', // 设置背景色
    title: {
      text: '热门玩法活跃度占比',
      left: 'center'
    },
    tooltip: {
      trigger: 'item'
    },
    legend: {
      orient: 'vertical',
      left: 'left'
    },
    series: [
      {
        name: '热门玩法',
        type: 'pie',
        radius: '50%',
        data: hotData
      }
    ]
  }
}

// 热门玩法饼图颜色
const hotPieColors = [
  '#a0d7e2', '#c7e8b7', '#667896','#c6b0c3','#52b6bf',
  '#89d0a6', '#bbd48f', '#77a4cd', '#eeb9b4', '#9b7db5',
]

/**
 * 表格中的“总活跃度”数值 => 显示为 x.x万
 * 如 43430 => 4.3万
 */
function formatScore(row, column, cellValue) {
  const val = Number(cellValue) || 0
  // 保留1位小数，比如 43430 => 4.343 => 4.3万
  const wVal = (val / 10000).toFixed(1)
  return wVal + '万'
}

// 工具函数：日期转 YYYY-MM-DD
function formatDate(dateObj) {
  // 如果 dateObj 不是 Date 实例，则尝试转换
  if (!(dateObj instanceof Date)) {
    dateObj = new Date(dateObj)
  }
  const y = dateObj.getFullYear()
  let m = dateObj.getMonth() + 1
  let d = dateObj.getDate()
  if (m < 10) m = '0' + m
  if (d < 10) d = '0' + d
  return `${y}-${m}-${d}`
}

// 用于动态计算模态框的顶部位置
const dialogTop = ref(0)

// 监听滚动事件，动态调整模态框的 top 值
const updateDialogTop = () => {
  // 动态获取当前视口高度，减去 header/footer 的高度（可根据实际情况调整）
  const currentWidth = window.innerWidth

  if (currentWidth <= 768) {
    dialogTop.value = 768 / window.innerWidth * window.scrollY + 100;
    // console.log('windows is', window)
    // console.log('window.innerWidth', window.innerWidth, ' window.scrollY=', window.scrollY, ' dialogTop.value=', dialogTop.value);
  } else {
    dialogTop.value = 0
  }

}

onMounted(() => {
  window.addEventListener('scroll', updateDialogTop)

  // console.log(logPrefix, '组件已挂载，默认发起一次查询')
  onSearch()
})

// 移除监听器
watch(dateDialogVisible, (newVal) => {
  if (!newVal) {
    window.removeEventListener('scroll', updateDialogTop)
  }
})

// 获取行的 class name，用于设置不同的行颜色
function getRowClassName({ rowIndex }) {
  return rowIndex % 2 === 0 ? 'even-row' : 'odd-row'
}

// 12. 表头单元格样式
function headerCellStyle() {
  return {
    backgroundColor: '#4a649e',
    color: 'white',
    fontWeight: 'bold',
    textAlign: 'center',
    fontSize: '16px'
  }
}

// 13. 表头行样式
function headerRowStyle() {
  return { backgroundColor: '#f2f2f2', fontWeight: 'bold' };
}

// 打开选择日期的对话框
const showDateDialog = () => {
  dateDialogVisible.value = true
}

// 用户选择日期后，更新选定的日期并关闭模态框
const selectDate = (date) => {
  selectedPieDate.value = date
  dateDialogVisible.value = false
  updatePieAndTable()  // 选择日期后更新图表和表格
}

// 打开快速选择模态框
const quickSelectDialogVisible = ref(false)

const showQuickSelectDialog = () => {
  quickSelectDialogVisible.value = true
}

// 选择快速选择日期并更新
const selectQuickDate = (value) => {
  quickSelect.value = value
  quickSelectDialogVisible.value = false

  const today = new Date()
  if (value === '今天') {
    startDate.value = formatDate(today)
    endDate.value = null
  } else if (value === '昨天') {
    const yest = new Date()
    yest.setDate(today.getDate() - 1)
    startDate.value = formatDate(yest)
    endDate.value = null
  } else if (value === '前天') {
    const beforeYest = new Date()
    beforeYest.setDate(today.getDate() - 2)
    startDate.value = formatDate(beforeYest)
    endDate.value = null
  }
}

const playSelectDialogVisible = ref(false)
// // 打开选择玩法的模态框
// const showPlaySelectDialog = () => {
//   playSelectDialogVisible.value = true
// }

// 选择玩法并更新
const selectPlay = (play) => {
  selectedPlay.value = play
  playSelectDialogVisible.value = false
  updatePieAndTable()  // 选择玩法后更新图表和表格
}
</script>

<style scoped>
.chart-box {
  margin: 20px 0;
  background-color: #ffe; /* 淡黄色底色 */
}

.loading-dialog .el-dialog__header {
  display: none; /* 隐藏标题栏, 根据需要可以保留 */
}

.el-radio /deep/ .el-radio__label {
  font-size: 16px;
}

.centered-dialog .el-dialog {
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  max-height: 80%;  /* 限制最大高度，避免页面过长时超出视口 */
  overflow: auto;   /* 让模态框内容可滚动 */
}
</style>
